module.exports = __webpack_public_path__ + "static/media/linkedin-payment-3-mobile-en.fe61b132.png";